import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { FunctionRegistryService } from '../../../function-registry/function-registry.service';
import { environment } from '../../../../environment/environment';
import { DataSharingService } from '../../../data-sharing/data-sharing.service';

export function moduleData(componentDataSourceService: ComponentDataSourceService, functionRegistryService: FunctionRegistryService) {
  // Get the data sharing service from the component data source service
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);
  
  return {
    name: 'ModuleData',
    description: 'Gets individual module data for editing',
    execute: (params?: LoadDataParams) => {
      
      // Get the module version data from the data sharing service
      const moduleVersionData = dataSharingService.getData('editing_module_version');
      
      if (!moduleVersionData?.module_id) {
        console.error('[moduleData] No module version data found in data sharing service');
        console.error('[moduleData] Available keys in data sharing service:', dataSharingService.getAllKeys());
        return of({ items: [], totalCount: 0 });
      }

      
      return componentDataSourceService.http.get<any>(
        `${environment.apiUrl}/events/modules/${moduleVersionData.module_id}`,
        params?.queryParams ? { params: params.queryParams } : {}
      ).pipe(
        tap(result => {
        }),
        catchError(error => {
          console.error('[moduleData] Error fetching module data:', error);
          if (error.error) {
            console.error('[moduleData] Error response body:', error.error);
          }
          return of({ items: [], totalCount: 0 });
        }),
        map(result => {
          
          // Debug: Log specific fields that SurveyJS needs
          if (result) {
            
            // Debug: Log ALL keys in the result
          }
          
          // For SurveyJS, we need to return the data in the format expected by dynamic form component
          // The dynamic form component expects result.data[0] to contain the form data
          const finalResult = {
            data: result ? [result] : [],
            totalCount: result ? 1 : 0
          };
          return finalResult;
        })
      );
    },
    settings: {
      columns: [
        { key: 'module_id', header: 'Module ID', type: 'text' },
        { key: 'name', header: 'Navn', type: 'text' },
        { 
          key: 'description', 
          header: 'Beskrivelse', 
          type: 'text',
          formatter: (row: any) => {
            const descriptions = row.descriptions || {};
            return descriptions.da || descriptions.dk || descriptions.danish || '';
          }
        },
        { key: 'visibility', header: 'Synlighed', type: 'text' }
      ],
      pageable: false,
      sortable: false,
      rowHover: false
    }
  }
}